import { createContext, useContext } from 'react';

export const AppVersionContext = createContext({
  appVersion: null,
  loading: true,
});

const BUNDLED_FRONTEND_VERSION = process.env.REACT_APP_VERSION || null;

// versions.json is generated at publish time; local dev servers fall back to
// the version bundled from package.json at build time.
export const frontendVersionFromPackages = (
  packages,
  fallback = BUNDLED_FRONTEND_VERSION,
) => {
  const value = packages?.frontend;
  return typeof value === 'string' && value.trim() ? value.trim() : fallback;
};

export const appVersionIsLoading = (checkedPath, currentPath) =>
  checkedPath !== currentPath;

export const packageVersionsChanged = (previous, current) =>
  previous !== null && JSON.stringify(previous) !== JSON.stringify(current);

export const useAppVersion = () => useContext(AppVersionContext);
